// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import * as CryptoJS from 'crypto-js';
var cv = '';
function generateRandomString(length) {
  var text = '';
  let codeVerifier = localStorage.getItem('code_verifier');
  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== '') {
    cv = codeVerifier;
    return codeVerifier;
  } else {
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    for (var i = 0; i < length; i++) {
      text += possible.charAt(((Date.now() * i) * Date.now() + Date.now()) % possible.length);
    }
    cv = text;
    localStorage.setItem('code_verifier', cv);
    return text;
  }
}

function generateCodeChallenge(codeVerifier) {
  const codeChallange = base64URL(CryptoJS.SHA256(codeVerifier));
  
  return codeChallange + '&code_challenge_method=S256';
}

function base64URL(string: any) {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}

export const environment = {
  envName: 'prod',
  env: 'prod',
  production: true,
  hostname: 'msts.toyota.com',
  redirectBaseUrl:'',
  // reqtafBaseUrl:'https://x8bqlgk3q5.execute-api.us-east-1.amazonaws.com/prod/api/',  
  // createtafBaseUrl:'https://mk8jtyawt9.execute-api.us-east-1.amazonaws.com/prod/api/',
  // reqhistoryBaseUrl:'https://acxfjl5c05.execute-api.us-east-1.amazonaws.com/prod/api/',  
  // updatetafBaseUrl:'https://jgaf8fmmk3.execute-api.us-east-1.amazonaws.com/prod/api/',
  // setuptimeBaseUrl: 'https://18sm3tbvab.execute-api.us-east-1.amazonaws.com/prod/itst/',
  // setupLocBaseUrl: 'https://wp9v5b41tb.execute-api.us-east-1.amazonaws.com/prod/itst/',
  // setupAgentBaseUrl: 'https://s11fq1u098.execute-api.us-east-1.amazonaws.com/prod/itst/',
  // reportBaseUrl: 'https://huz3ahmaie.execute-api.us-east-1.amazonaws.com/prod/itst/',  
  // scheduleVehicleBaseUrl: 'https://stxvbwa501.execute-api.us-east-1.amazonaws.com/prod/itst/',
  // setupCapacityBaseUrl:'https://sb57een8od.execute-api.us-east-1.amazonaws.com/prod/itst/',
  // saveTokenBaseUrl: 'https://8n2clfqd42.execute-api.us-east-1.amazonaws.com/subprod/api/saveToken',
  reqtafBaseUrl:'https://api.prod.msts.toyota.com/', 
  createtafBaseUrl:'https://api.prod.msts.toyota.com/',
  reqhistoryBaseUrl:'https://api.prod.msts.toyota.com/',  
  updatetafBaseUrl:'https://api.prod.msts.toyota.com/',
  setuptimeBaseUrl: 'https://api.prod.msts.toyota.com/',
  setupLocBaseUrl: 'https://api.prod.msts.toyota.com/',
  setupAgentBaseUrl: 'https://api.prod.msts.toyota.com/',
  reportBaseUrl: 'https://api.prod.msts.toyota.com/',
  scheduleVehicleBaseUrl: 'https://api.prod.msts.toyota.com/',
  setupCapacityBaseUrl:'https://api.prod.msts.toyota.com/',
  saveTokenBaseUrl: 'https://api.prod.msts.toyota.com/',
  loginBaseUrl: 'https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb/oauth2/v2.0/authorize',
  client_id: '1d85aa4f-5e4a-465c-b5b3-777ea3320c99',
  redirect_uri:'https://msts.toyota.com',
  loginParameters: '&response_type=code&response_mode=query&scope=openid&',
  state:'23343',
  code_verifier: generateRandomString(128),
  code_challenge: generateCodeChallenge(cv),
  grant_type: 'authorization_code',
  logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout',
  tokenUrl: 'https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb/oauth2/v2.0/token',
  loginSaveAudit: 'https://api.prod.msts.toyota.com/',
  // hotelUrl: 'https://4d5mxedky5.execute-api.us-east-1.amazonaws.com/prod/itst/',
  hotelUrl: 'https://api.prod.msts.toyota.com/',
  downloadUrl: 'https://dyeerpzus4qla.cloudfront.net/',
  // fileToken: 'https://6eyfb7ygoj.execute-api.us-east-1.amazonaws.com/prod/sts/',
  // signedUrl :'https://fo4cn3f2b5.execute-api.us-east-1.amazonaws.com/prod/itst/',
  fileToken: 'https://api.prod.msts.toyota.com/',
  signedUrl :'https://api.prod.msts.toyota.com/',
  bucketName : 'itst-reports-prod/agents-profileImgs'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
